export default {
    apiBase: 'http://localhost',
    apiPort: 8099,
    apiPath: '/graphql',
    // serverPort is used to bind the web server; the serverBase is used to access it via browser
    serverBase: 'https://foodsafetycheck.ifs-certification.com',
    serverPort: 8098,
    IFSPortalUrl: 'https://www.ifs-certification.com/fsc_redirect.php',
};
